import { render, staticRenderFns } from "./CategoryCognize.vue?vue&type=template&id=01a30a78&scoped=true&"
import script from "./CategoryCognize.vue?vue&type=script&lang=js&"
export * from "./CategoryCognize.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCognize.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CategoryCognize.vue?vue&type=style&index=1&id=01a30a78&scoped=true&lang=css&"
import style2 from "../../constant/css/detail.css?vue&type=style&index=2&id=01a30a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a30a78",
  null
  
)

export default component.exports